module.exports = __webpack_public_path__ + "static/media/donut-chart-increased.d4dbd0a9.svg";